import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ptTranslation from "./locales/pt/translation.json";

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    react: {
      bindI18n: "languageChanged",
      bindI18nStore: "",
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
      useSuspense: false,
    },
    fallbackLng: "pt",
    supportedLngs: ["pt"],
    resources: {
      pt: {
        translation: ptTranslation,
      },
    },
    ns: ["translation"],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    // debug: true, // enable to see logs in console
    lng: "pt",
  });
export default i18n;
